import { useSelector, useDispatch } from "react-redux";
import type { RootState } from "../redux/store";
import { createSlice } from "@reduxjs/toolkit";

// Slice definition
const userIdSlice = createSlice({
	name: "userId",
	initialState: null as string | null,
	reducers: {
		setUserId: (_state, action: { payload: string | null }) => action.payload,
	},
});

export const { setUserId: setUserIdAction } = userIdSlice.actions;
export const userIdReducer = userIdSlice.reducer;

// Hooks
export function useUserId(): string | null {
	return useSelector((state: RootState) => state.userId);
}

export function useSetUserId() {
	const dispatch = useDispatch();
	return (userId: string | null) => {
		dispatch(setUserIdAction(userId));
	};
}
